import React from "react";
import "./LegalContent.styles.css";
import { Helmet } from "react-helmet";

const DisclaimerPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cm-legal-content-container">
      <Helmet>
        <title>Globalskyfare | Disclaimer</title>
      </Helmet>
      <div className="inner-banner">
        <h2 className="cm-section-h cm-txt-center cm-white-col">Disclaimer</h2>
      </div>
      <div className="cm-section cm-page-center cm-lr-pad pb-10">

        <p>This disclaimer aims to set forth the general limitation of liability and warranties that govern all users' access and use. This disclaimer of warranties and general limitation of liability contained in this legal Disclaimer must be submitted to and accepted.</p>
        <p>
          <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> does not guarantee or represent the authenticity of the information on its website, although it makes a good-faith attempt to ensure that it is correct as of the date of publication.
        </p>
        <p>
          Therefore, reliance on such information is entirely at the user's risk, not the website's. <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> is the only owner of all intellectual property rights to the content on the website. Users are responsible for using and protecting the UserID and password they enter on our website.
        </p>
        <p>Regardless of whether <a href="https://Globalskyfare.com/"><strong>Globalskyfare.com</strong></a> approved the connection, Globalskyfare.com disclaims all liability for the information, statements, offers, claims, and visual components of any website connected to or from the website.</p>
      </div>
    </div>
  );
};

export default DisclaimerPage;
